import * as types from "../actions/actionTypes";

const initialState = {
  user: null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_USER:
      return { ...state, user: null };
    case types.LOGIN_USER_RESPONSE:
      return { ...state, user: action.payload };

    default:
      return state;
  }
};

export default login;
